import * as React from 'react'
import {Button} from '@frontrow/console/src/components/button'
import {ButtonAsync} from '@frontrow/console/src/components/button-async'
import {Dialog, DialogDismiss, DialogHeading} from '@ariakit/react'
import * as dialogStyles from '@frontrow/console/src/components/dialog/dialog.module.scss'

type Props = {
  show: boolean
  handleSubmit: () => Promise<void>
  handleClose: () => void
}

export default function RosterSyncSubmitModal(props: Props): React.ReactElement {
  const {handleClose, handleSubmit, show} = props

  return (
    <Dialog
      open={show}
      onClose={handleClose}
      backdrop={<div className={dialogStyles.backdrop} />}
      className={dialogStyles.dialog}
      portal
      unmountOnHide
      hideOnEscape={false}
      hideOnInteractOutside={false}
    >
      <div className={dialogStyles.header}>
        <DialogHeading className={dialogStyles.title}>Confirm Rostering</DialogHeading>
        <DialogDismiss className={dialogStyles.closeButton}>
          <span aria-hidden="true">&times;</span>
        </DialogDismiss>
      </div>
      <div className={dialogStyles.body}>
        <p>
          Once you confirm, all teachers, students and courses will be created or updated as shown.
          This action cannot be undone.
        </p>
      </div>
      <div className={dialogStyles.footer}>
        <Button style="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <ButtonAsync onClick={handleSubmit} type="submit" style="primary">
          Confirm
        </ButtonAsync>
      </div>
    </Dialog>
  )
}
